import React from "react"
import {Deal} from "@irati/types"

import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import FormattedMessage from "@irati/utils/lang"
import Modal from "@irati/ui/src/Modal/Modal"
import {H3} from "@irati/ui/src//Typography/Heading"
import Spacing from "@irati/ui/src/Spacing"
import {Hr} from "@irati/ui/src/Layout"
import {Label2} from "@irati/ui/src/Labels"
import {Body} from "@irati/ui/src/Typography"

import RewardPrice from "../../DealSelectProducts/ProductForms/shared/Quantity/RewardPrice"


interface Props {
  deal: Deal,
  show: boolean,
  onHide: () => any,
  isAdmin?: boolean
}

const RewardProductPreview: React.FC<Props> = ({show, onHide, deal, isAdmin}) => {


  return (
    <Modal
      show={show}
      onHide={onHide}
      renderHeader={() => (
        <Spacing marginTop={4} marginLeft={4} paddingBottom={0}>
          <H3>
            {deal.header}
          </H3>
        </Spacing>
      )}>
      {isAdmin
        ? <Body>{deal.description}</Body>
        : deal.productConfig?.products.map((p) =>
          <Flex width="80%" justifyContent="space-between" minHeight="60px" alignItems="center">
            <Label2>{p.name}</Label2>
            <RewardPrice product={p} />
          </Flex>
      )}
      <Hr />
      <Flex justifyContent="flex-end" marginTop={3}>
        <Button primary onClick={onHide}>
          <FormattedMessage id="perks.components.simpleModal.close" />
        </Button>
      </Flex>
    </Modal>
  )
}

export default RewardProductPreview
